export default {"src":"/_next/static/media/cs-logo-mobile.b2884304.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};